import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap';
import DataTable from '../common/DataTable';
import { RateCardHistoryColumns } from '../../constant';
import { getServicesByRateCardHistory } from '../../store/actions/serviceRateCard.action';
import PropTypes from 'prop-types';

/* istanbul ignore next */
export default function RateCardHistoryDialog(props) {
    const { modalShow, setModalShow, rateCardDetails } = props;
    const [rateCardListData, setRateCardListData] = React.useState([]);

    useEffect(() => {
        if (modalShow.show) {
            fetchRateCardHistory();
        }
    }, [modalShow.show]);

    const fetchRateCardHistory = async () => {
        try {
            // Simulating an API call to fetch rate card history
            let historyPayload = `${rateCardDetails.CompanySellerId}/${modalShow.item.AccountingServiceMaster_Id}`;
            const response = await getServicesByRateCardHistory(historyPayload); // Replace with actual API endpoint
            if (response?.data?.Status === 200) {
                setRateCardListData(response.data.EntityList);
            }
        } catch (error) {
            console.error("Error fetching rate card history:", error);
        }
    };

    return (
        <Modal
            size="lg"
            show={modalShow.show}
            onHide={() => {
                setModalShow({ show: false, item: null });
            }}
            centered>
            <Modal.Header >
                <div className="modal-main-div">
                    <h6 >History</h6>
                </div>
                <div className="modalDeleteWrapper">
                    <button type="button" className="btn-close" aria-label="Close" onClick={() => setModalShow({ show: false, item: null })}></button>
                </div>
            </Modal.Header>
            <Modal.Body className='fontFix'>
                <div className='row mb-3'>
                    <div className='col-4'>
                        <div>Service Type: <b>{modalShow.item.ServiceType}</b></div>
                        <div>Transaction Type: <b>{modalShow.item.TransactionType}</b></div>
                    </div>
                    <div className='col-4'>
                        <div>Charge Type: <b>{modalShow.item.PackingType}</b></div>
                        <div>Size Type: <b>{modalShow.item.SizeType}</b></div>
                    </div>
                    <div className='col-4'>
                        <div>Charge/Unit: <b>{modalShow.item.UnitType}</b></div>
                    </div>
                </div>
                <div className="main_content_table_history tableFixHead">
                    <DataTable
                        headers={RateCardHistoryColumns}
                        tableData={rateCardListData}
                    />
                </div>
            </Modal.Body>
        </Modal>
    )
}

RateCardHistoryDialog.propTypes = {
    modalShow: PropTypes.shape({
        show: PropTypes.bool.isRequired,
        item: PropTypes.shape({
            AccountingServiceMaster_Id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            ServiceType: PropTypes.string,
            TransactionType: PropTypes.string,
            PackingType: PropTypes.string,
            SizeType: PropTypes.string,
            UnitType: PropTypes.string
        })
    }).isRequired,
    setModalShow: PropTypes.func.isRequired,
    rateCardDetails: PropTypes.shape({
        CompanySellerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
    }).isRequired
};